class GuideTaillesV4 {
  constructor() {
    this.sizeGuide = document.querySelectorAll('.size-guide-mobile');
    this.categories = document.querySelectorAll('.category-mobile');
    this.products = document.querySelectorAll('.product-mobile');
    this.productNames = document.querySelectorAll('.product-name-mobile');
    this.productContents = document.querySelectorAll('.product-content-mobile');
    this.selectedCategoryId = null;
    this.selectedProductId = null;
    this.selectedDiffId = null;
    if (this.sizeGuide.length > 0) {
      this.sizeGuide.forEach((element) => {
        element.getAttribute('data-size-category-id')
          ? (this.selectedCategoryId = element.getAttribute(
              'data-size-category-id'
            ))
          : null;
        element.getAttribute('data-size-product-id')
          ? (this.selectedProductId = element.getAttribute(
              'data-size-product-id'
            ))
          : null;
        element.getAttribute('data-diff-id')
          ? (this.selectedDiffId = element.getAttribute('data-diff-id'))
          : null;
      });
    }
    this.events();
  }
  events() {
    this.initStyles();
    this.addEventListeners();
    document
      .querySelectorAll('.size-guide-container-mobile')
      .forEach((element) => {
        element.classList.remove('invisible');
      });
  }

  initStyles() {
    if (this.categories) {
      this.categories.forEach((category, index) => {
        const id = category.getAttribute('data-id')
          ? category.getAttribute('data-id')
          : null;
        if (id === this.selectedCategoryId) {
          category.classList.remove('opacity-30');
          if (category.querySelector('.chevron-down'))
            category.querySelector('.chevron-down').classList.add('hidden');
          if (category.querySelector('.chevron-up'))
            category.querySelector('.chevron-up').classList.remove('hidden');
        } else {
          category.classList.add('opacity-30');
          if (category.querySelector('.chevron-down'))
            category.querySelector('.chevron-down').classList.remove('hidden');
          if (category.querySelector('.chevron-up'))
            category.querySelector('.chevron-up').classList.add('hidden');
        }
      });
    }

    if (this.products) {
      this.products.forEach((product) => {
        if (
          product.getAttribute('data-category-id') === this.selectedCategoryId
        ) {
          console.log(this.selectedCategoryId);
          console.log(product.getAttribute('data-category-id'));
          console.log('===');
          product.classList.add('block');
          product.classList.remove('hidden');
        } else {
          product.classList.remove('block');
          product.classList.add('hidden');
        }
      });
    }

    if (this.arrows) {
      this.arrows.forEach((product) => {
        const id = product.getAttribute('data-category-id')
          ? product.getAttribute('data-category-id')
          : null;
        if (id === this.selectedCategoryId) {
          product.classList.remove('hidden');
        } else {
          product.classList.add('hidden');
        }
      });
    }
    if (this.tracks) {
      this.tracks.forEach((product) => {
        const id = product.getAttribute('data-category-id')
          ? product.getAttribute('data-category-id')
          : null;
        if (id === this.selectedCategoryId) {
          product.classList.remove('hidden');
        } else {
          product.classList.add('hidden');
        }
        id === this.selectedCategoryId
          ? product.classList.remove('hidden')
          : product.classList.add('block');
      });
    }

    if (this.productNames) {
      this.productNames.forEach((productName) => {
        const id = productName.getAttribute('data-id')
          ? productName.getAttribute('data-id')
          : null;
        const categoryId = productName.getAttribute('data-category-id')
          ? productName.getAttribute('data-category-id')
          : null;
        if (
          id === this.selectedProductId &&
          categoryId == this.selectedCategoryId
        ) {
          productName.classList.remove('opacity-30');
          if (productName.querySelector('.product-name-chevron-down'))
            productName
              .querySelector('.product-name-chevron-down')
              .classList.add('hidden');
          if (productName.querySelector('.product-name-chevron-up'))
            productName
              .querySelector('.product-name-chevron-up')
              .classList.remove('hidden');
        } else {
          productName.classList.add('opacity-30');
          if (productName.querySelector('.product-name-chevron-down'))
            productName
              .querySelector('.product-name-chevron-down')
              .classList.remove('hidden');
          if (productName.querySelector('.product-name-chevron-up'))
            productName
              .querySelector('.product-name-chevron-up')
              .classList.add('hidden');
        }
      });
    }

    if (this.productContents) {
      this.productContents.forEach((productContent) => {
        const categoryId = productContent.getAttribute('data-category-id')
          ? productContent.getAttribute('data-category-id')
          : null;
        const productId = productContent.getAttribute('data-product-id')
          ? productContent.getAttribute('data-product-id')
          : null;
        const dataDomKey = productContent.getAttribute('data-dom-key')
          ? productContent.getAttribute('data-dom-key')
          : null;
        // const diffId = productContent.getAttribute('data-diff-id')
        //   ? productContent.getAttribute('data-diff-id')
        //   : null;
        // productContent.classList.remove('hidden');
        if (
          categoryId === this.selectedCategoryId &&
          productId === this.selectedProductId &&
          dataDomKey === this.selectedCategoryId
        ) {
          productContent.classList.remove('hidden');
          productContent.classList.add('grid');
        } else {
          productContent.classList.add('hidden');
          productContent.classList.remove('grid');
        }
      });
    }
  }

  addEventListeners() {
    if (this.categories && this.sizeGuide) {
      this.categories.forEach((category) => {
        category.addEventListener('click', (e) => {
          e.preventDefault();
          this.categoryClicked(category);
        });
      });
    }

    if (this.productNames && this.sizeGuide) {
      this.productNames.forEach((productName) => {
        productName.addEventListener('click', (e) => {
          e.preventDefault();
          this.productNameClicked(productName);
        });
      });
    }
  }

  categoryClicked(category) {
    const id = this.selectedCategoryId;
    this.selectedCategoryId =
      this.selectedCategoryId === category.getAttribute('data-id')
        ? (this.selectedCategoryId = null)
        : (this.selectedCategoryId = category.getAttribute('data-id'));
    this.selectedProductId = category.getAttribute('data-first-product-id');
    this.initStyles();
    const yOffset = -100;
    const y =
      category.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  productNameClicked(productName) {
    const id = this.selectedProductId;
    // remove hidden and add flex
    this.selectedCategoryId = productName.getAttribute('data-category-id');
    this.selectedProductId =
      this.selectedProductId === productName.getAttribute('data-id')
        ? null
        : productName.getAttribute('data-id');
    this.selectedDiffId = productName.getAttribute('data-diff-id');
    // this.sizeGuide.setAttribute('data-category-id', this.selectedCategoryId);
    // this.sizeGuide.setAttribute('data-product-id', this.selectedProductId);
    // Prevent null value that make the elements collapse
    // if (this.selectedProductId === null) this.selectedProductId = id;
    this.initStyles();
    // productName.scrollIntoView();
    const yOffset = -100;
    const y =
      productName.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}

export default GuideTaillesV4;
